import { IRoute, ICrudRoute } from '@interfaces/App.interface';
import { generateCRUDRoutes } from './routes.utils';

import Assets from '@pages/DataBase/Flavors/Assets/Assets';
import ItemPage from '@pages/DataBase/Flavors/ItemPage';
import EventGenerationRulePage from '@pages/DataBase/EventGenerationRules/EGRPage';
import DevicesPhysical from '@pages/DataBase/Flavors/Devices/DevicesPhysical';
import ItemsInCustody from '@pages/DataBase/Flavors/ItemInCustody/ItemsInCustody';
import WipParts from '@pages/DataBase/Flavors/WipParts/WipParts';
import Devices from '@pages/DataBase/Flavors/Devices/Devices';
import Livestock from '@pages/DataBase/Flavors/Livestock/Livestock';
import People from '@pages/DataBase/Flavors/People/People';
import Processes from '@pages/DataBase/Flavors/Processes/Processes';
import Vehicles from '@pages/DataBase/Flavors/Vehicles/Vehicles';
import Locations from '@pages/DataBase/Flavors/Locations/Locations';
import DevicesAvailable from '@pages/DataBase/Flavors/Devices/DevicesAvailable';
import DevicesIssued from '@pages/DataBase/Flavors/Devices/DevicesIssued';
import DevicesPassive from '@pages/DataBase/Flavors/Devices/DevicesPassive';
import DevicesVirtual from '@pages/DataBase/Flavors/Devices/DevicesVirtual';
import DevicesToCharge from '@pages/DataBase/Flavors/Devices/DevicesToCharge';
import DevicesInfrastructure from '@pages/DataBase/Flavors/Devices/DevicesInfrastructure';
import ItemTypes from '@pages/DataBase/Flavors/ItemTypes/ItemTypes';
import ItemTypePage from '@pages/DataBase/Flavors/ItemTypes/ItemTypePage';
import Items from '@pages/DataBase/Flavors/Items/Items';
import ItemRelations from '@pages/DataBase/Flavors/ItemRelations/ItemRelations';
import ItemRelationPage from '@pages/DataBase/Flavors/ItemRelations/ItemRelationPage';
import ItemRelationTypes from '@pages/DataBase/Flavors/ItemRelations/ItemRelationTypes';

//#region CRUD
const crudEntitiesData: ICrudRoute[] = [
  //ITEM
  { aclId: 'tsElement', entityName: 'item', DataTable: Items, FormPage: ItemPage },
  { aclId: 'tsElement', entityName: 'allItem', DataTable: Items, FormPage: ItemPage },
  {
    aclId: 'tsElementRelation',
    entityName: 'itemRelation',
    DataTable: ItemRelations,
    FormPage: ItemRelationPage,
  },
  { aclId: 'tsElement', entityName: 'itemBytype', DataTable: Items, FormPage: ItemPage },
  //DEVICES
  { aclId: 'tsElement', entityName: 'device', DataTable: Devices, FormPage: ItemPage },
  //ASSETS
  { aclId: 'tsElement', entityName: 'asset', DataTable: Assets, FormPage: ItemPage },
  //LIVESTOCK
  {
    aclId: 'tsElement',
    entityName: 'livestock',
    DataTable: Livestock,
    FormPage: ItemPage,
    customEntityName: 'livestock',
  },
  //LOCATION
  { aclId: 'tsElement', entityName: 'location', DataTable: Locations, FormPage: ItemPage },
  //PEOPLE
  {
    aclId: 'tsElement',
    entityName: 'person',
    DataTable: People,
    FormPage: ItemPage,
    customEntityName: 'people',
  },
  //PROCESS
  {
    aclId: 'tsElement',
    entityName: 'process',
    DataTable: Processes,
    FormPage: ItemPage,
    customEntityName: 'processes',
  },
  //VEHICLE
  {
    aclId: 'tsElement',
    entityName: 'vehicle',
    DataTable: Vehicles,
    FormPage: ItemPage,
  },
  //WIP PART
  { aclId: 'tsElement', entityName: 'wipPart', DataTable: WipParts, FormPage: ItemPage },
  //ItemsInCustody
  {
    aclId: 'tsElement',
    entityName: 'itemInCustody',
    DataTable: ItemsInCustody,
    FormPage: ItemPage,
    customEntityName: 'itemsInCustody',
  },
  //ItemType
  { aclId: 'tsElementType', entityName: 'itemType', DataTable: ItemTypes, FormPage: ItemTypePage },
];
//#endregion

//#region Devices
const devicesRoutes: IRoute[] = [
  {
    matchPath: '/devicesPhysical',
    pageComponent: DevicesPhysical,
    id: 'devicesPhysical',
    pageTitle: 'Physical Devices',
    aclId: 'tsElement',
    canFilter: true,
  },
  {
    matchPath: '/devicesAvailable',
    pageComponent: DevicesAvailable,
    id: 'devicesAvailable',
    pageTitle: 'Available Devices',
    aclId: 'tsElement',
    canFilter: true,
  },
  {
    matchPath: '/devicesIssued',
    pageComponent: DevicesIssued,
    id: 'devicesIssued',
    pageTitle: 'Issued Devices',
    aclId: 'tsElement',
    canFilter: true,
  },
  {
    matchPath: '/passiveTags',
    pageComponent: DevicesPassive,
    id: 'passiveTags',
    pageTitle: 'Passive devices',
    aclId: 'tsElement',
    canFilter: true,
  },
  {
    matchPath: '/devicesVirtual',
    pageComponent: DevicesVirtual,
    id: 'devicesVirtual',
    pageTitle: 'Virtual Devices',
    aclId: 'tsElement',
    canFilter: true,
  },
  {
    matchPath: '/devicesToCharge',
    pageComponent: DevicesToCharge,
    id: 'devicesToCharge',
    pageTitle: 'Devices to charge',
    aclId: 'tsElement',
    canFilter: true,
  },
  {
    matchPath: '/devicesInfrastructure',
    pageComponent: DevicesInfrastructure,
    id: 'devicesInfrastructure',
    pageTitle: 'Devices infrastructure',
    aclId: 'tsElement',
    canFilter: true,
  },
];
//#endregion

//#region Item
const customRoutes: IRoute[] = [
  {
    matchPath: '/item/:id',
    redirectPath: '/item/:id/view',
    pageComponent: ItemPage,
    id: 'itemView',
    pageTitle: 'View item',
    aclId: 'tsElement',
  },
  {
    matchPath: '/deviceType/:id/eventRule/new',
    pageComponent: EventGenerationRulePage,
    id: 'eventGenerationRuleNew',
    pageTitle: 'New event generation rule',
    aclId: 'taEventGenerationRule',
  },
  {
    matchPath: '/deviceType/:id/eventRule/:id/view',
    pageComponent: EventGenerationRulePage,
    id: 'eventGenerationRuleView',
    pageTitle: 'View event generation rule',
    aclId: 'taEventGenerationRule',
  },
  {
    matchPath: '/deviceType/:id/eventRule/:id/edit',
    pageComponent: EventGenerationRulePage,
    id: 'eventGenerationRuleEdit',
    pageTitle: 'Edit event generation rule',
    aclId: 'taEventGenerationRule',
  },
  /*   {
    matchPath: '/masterItemTypes',
    pageComponent: MasterItemTypes,
    id: 'masterItemTypes',
    pageTitle: 'Master item types',
    aclId: 'tsElementType',
  }, */
  { matchPath: '/items/type/:logicalId', pageComponent: Items, id: 'ItemsByType', pageTitle: 'ItemsByType', aclId: 'tsElement' },
  {
    matchPath: '/itemRelationTypes',
    pageComponent: ItemRelationTypes,
    id: 'ItemRelationTypes',
    pageTitle: 'ItemRelationTypes',
    aclId: 'tsElementRelationType',
  },
];
//#endregion

export default [...devicesRoutes, ...customRoutes, ...generateCRUDRoutes(crudEntitiesData)];
